import React from "react";

export const ClosedDirectory = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 19H5a1 1 0 01-1-1V7a1 1 0 011-1h3.697a1 1 0 01.555.168l2.496 1.664a1 1 0 00.555.168H19a1 1 0 011 1v9a1 1 0 01-1 1z"
      stroke="#999"
      strokeLinecap="round"
    />
  </svg>
);

export const OpenDirectory = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 9.95V9a1 1 0 00-1-1h-6.697a1 1 0 01-.555-.168L9.252 6.168A1 1 0 008.697 6H5a1 1 0 00-1 1v11a1 1 0 001 1h14.22a1 1 0 00.97-.758l1.5-6A1 1 0 0020.72 11H6.78a1 1 0 00-.97.758L4.126 18.5"
      stroke="#999"
      strokeLinecap="round"
    />
  </svg>
);

export const js = (props) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 5.05l-6 14M16 7v8M12.536 9l6.928 4M19.464 9l-6.928 4"
        stroke="#999"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const css = (props) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 4v16M16 4v16M4 8h16M4 16h16"
        stroke="#999"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const json = (props) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 6a1 1 0 011-1h8.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V18a1 1 0 01-1 1H6a1 1 0 01-1-1V6z"
        stroke="#999"
        strokeLinecap="round"
      />
      <path d="M14 5v4a1 1 0 001 1h4" stroke="#999" strokeLinecap="round" />
    </svg>
  );
};

export const html = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="prefix__a" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.046 12.75l-4.45 5.085c-.334.382-.486 1.02-.152 1.401.307.352.935.352 1.242 0m0 0l5.064-5.785c.334-.382.334-1.02 0-1.402l-5.063-5.785c-.308-.352-.935-.352-1.243 0-.334.381-.182 1.02.152 1.401l4.45 5.085"
      />
      <path d="M9.483 6.264a.78.78 0 00-1.17 0L3.25 12.049c-.333.382-.333 1.02 0 1.402l5.064 5.785c.307.352.94.352 1.247 0 .334-.381.177-1.02-.157-1.401l-4.45-5.085 4.45-5.085c.334-.382.413-1.02.079-1.401z" />
    </mask>
    <path
      clipRule="evenodd"
      d="M19.046 12.75l-4.45 5.085c-.334.382-.486 1.02-.152 1.401.307.352.935.352 1.242 0m0 0l5.064-5.785c.334-.382.334-1.02 0-1.402l-5.063-5.785c-.308-.352-.935-.352-1.243 0-.334.381-.182 1.02.152 1.401l4.45 5.085"
      stroke="#9C9C9C"
      strokeWidth={2}
      mask="url(#prefix__a)"
    />
    <path
      d="M9.483 6.264a.78.78 0 00-1.17 0L3.25 12.049c-.333.382-.333 1.02 0 1.402l5.064 5.785c.307.352.94.352 1.247 0 .334-.381.177-1.02-.157-1.401l-4.45-5.085 4.45-5.085c.334-.382.413-1.02.079-1.401z"
      stroke="#9C9C9C"
      strokeWidth={2}
      mask="url(#prefix__a)"
    />
  </svg>
);

export const File = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="path-1-inside-1">
      <path d="M16.5689 5H9C8.44772 5 8 5.44772 8 6V26C8 26.5523 8.44772 27 9 27H23C23.5523 27 24 26.5523 24 26V12.1587L16.5689 5ZM16 6L23 13H16V6Z" />
    </mask>
    <path
      d="M16.5689 5H9C8.44772 5 8 5.44772 8 6V26C8 26.5523 8.44772 27 9 27H23C23.5523 27 24 26.5523 24 26V12.1587L16.5689 5ZM16 6L23 13H16V6Z"
      fill="#eee"
    />
    <path
      d="M16.0689 5V6.56889H17.0689V5H16.0689ZM22.1587 12.6587H24V11.6587H22.1587V12.6587ZM16.5689 5L17.2627 4.27982L16.9722 4H16.5689V5ZM24 12.1587H25V11.7335L24.6938 11.4385L24 12.1587ZM23 13V14H25.4142L23.7071 12.2929L23 13ZM16 6L16.7071 5.29289L15 3.58579V6H16ZM16 13H15V14H16V13ZM9 6H16.5689V4H9V6ZM9 6L9 6V4C7.89543 4 7 4.89543 7 6H9ZM9 26V6H7V26H9ZM9 26H7C7 27.1046 7.89543 28 9 28V26ZM23 26H9V28H23V26ZM23 26V28C24.1046 28 25 27.1046 25 26H23ZM23 12.1587V26H25V12.1587H23ZM15.8751 5.72018L23.3062 12.8789L24.6938 11.4385L17.2627 4.27982L15.8751 5.72018ZM23.7071 12.2929L16.7071 5.29289L15.2929 6.70711L22.2929 13.7071L23.7071 12.2929ZM16 14H23V12H16V14ZM15 6V13H17V6H15Z"
      fill="#eee"
      mask="url(#path-1-inside-1)"
    />
  </svg>
);
